import clsx from "clsx"
import Link from "next/link"
import { useRouter } from "next/router"
import routes from "routes"

type Props = {
  title: string
  isShowSettingIcon?: boolean
  path?: string
  isMypage?: boolean
}

const MyPageHeader: React.FC<Props> = ({
  title,
  isShowSettingIcon = false,
  path,
  isMypage,
}) => {
  const router = useRouter()

  return (
    <header
      className={clsx({
        "p-creatorMypage-header": true,
        "-isMypage": isMypage,
      })}
    >
      <div className="p-creatorMypage-header-inner">
        <h1 className="p-creatorMypage-header-title">{title}</h1>
        {path ? (
          <Link href={path}>
            <a className="p-creatorMypage-header-icon -back">
              <span className="sr-only">戻る</span>
            </a>
          </Link>
        ) : (
          <a
            className="p-creatorMypage-header-icon -back"
            href="#back"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault()
              router.back()
            }}
          >
            <span className="sr-only">戻る</span>
          </a>
        )}
        {isShowSettingIcon && (
          <Link href={routes.authPrivacySettings()}>
            <a className="p-creatorMypage-header-icon -edit">
              <span className="sr-only">情報編集</span>
            </a>
          </Link>
        )}
      </div>
    </header>
  )
}

export default MyPageHeader
